var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL3Usd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6764_94918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "url(#paint0_radial_6764_94918)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6764_94918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0243 7.8447C13.8679 8.0019 13.7531 8.19306 13.6869 8.40096L9.44921 19.6887H7.73999V21.42H10.9771L12.2244 17.9773L12.8181 16.2466L14.9761 10.1182L18.956 21.42H22.2593V19.6887H20.5434L16.3061 8.4006C16.2399 8.19288 16.1251 8.00178 15.9687 7.8447C15.7109 7.58556 15.3612 7.44 14.9966 7.44C14.6319 7.44 14.2822 7.58556 14.0243 7.8447Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6764_94918",
    x: 3.73999,
    y: 7.44,
    width: 22.5193,
    height: 21.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_94918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_94918",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6764_94918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45) scale(42.4264 28.5265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFFFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616783,
    stopColor: "#1A715C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6764_94918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL3Usd);
export default __webpack_public_path__ + "static/media/l3usd.d0fbb6a11f3037db9644bba5ff63b62e.svg";
export { ForwardRef as ReactComponent };